import DashboardLayout from "src/Modules/Users/Layouts/DashboardLayout.vue";

// Page Headers
import DefaultHeader from "src/Modules/Users/Pages/DefaultHeader";

// Pages
import Guide from 'src/Modules/Health/Pages/Guide';

const routes = [
    {
        path: '/Health/Guide',
        component: DashboardLayout,
        children: [
            {
                path: '',
                name: 'Guide',
                components: { default: Guide, header: DefaultHeader },
                meta: { authOnly: true }
            }
        ]
    },
];

export default routes;
